import { Link } from "react-router-dom";

const AiContentMarketingFeedback = () => {
  return (
    <>
      <div className="ai-wt-feedback-area pl-20 pr-20">
        <div className="container-fluid">
          <div className="ai-wi-feedback-bg ptb-120 rounded-3">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-xl-6">
                  <h2 className="aiwt-title text-white ff-risk-pri fs-48 mb-30">
                    What’s Saying Creative People-
                    <span className="ai-wt-brand-text fw-400">About Bot</span>
                  </h2>
                </div>
                <div className="col-xl-5">
                  <p className="text-white mb-30">
                    Streamline your video creation process by embedding your
                    videos into your authoring tool, LMS, LXP & more. Usually
                    our colleagues don't jump in the air when they but that we
                    haven't seen before.
                  </p>
                </div>
              </div>
              <div className="aiwt-feedback-wrapper">
                <div className="row">
                  <div className="col-xl-4">
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-1.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-2.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-3.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-1.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="text-center d-none d-xl-block">
                      <Link
                        href="/ai-content-marketing"
                        className="btn ai-wt-gd-bg-2 dark-bg-hover rounded-5 text-white fs-16 border-0 mt-30"
                      >
                        Get Started - It's Free
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-2.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="ai-wt-feedback-item ai-wt-bg-2 p-4 border-1 rounded-3 mt-20">
                      <p className="text-white">
                        "Our AI image solutions have exceeded our customers'
                        expectations. they appreciate the Here's a
                        opportunities. Here's a glimpse of don't haven't seen
                        before.their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction their positive feedback opportunities
                        satisfaction.."
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          src="assets/img/software-company/client-md-3.png"
                          alt=""
                        />
                        <div className="ail-content">
                          <h6 className="text-white fs-20 fw-600 mb-0">
                            Logan jon deo
                          </h6>
                          <p className="text-white fs-14 ff-dmsans mb-0">
                            Director at Webflow
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentMarketingFeedback;
